import { render, staticRenderFns } from "./EditorText.vue?vue&type=template&id=3fc8d294&scoped=true"
import script from "./EditorText.vue?vue&type=script&lang=js"
export * from "./EditorText.vue?vue&type=script&lang=js"
import style0 from "./EditorText.vue?vue&type=style&index=0&id=3fc8d294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc8d294",
  null
  
)

export default component.exports